export default "__VITE_ASSET__IaLkJ6yv__"